/**
 *
 *  Booking Panel
 *  Component
 *
 *  Created by Vladimir Shislyannikov on 09/12/2021.
 *  Copyright (c) 2021 iWoo Ltd. All rights reserved.
 *
 */

import React, {
  // useImperativeHandle,
  // useRef,
  useEffect,
  // useLayoutEffect,
  useCallback,
  useState
} from 'react';
import ReactDOM from 'react-dom';
import {
  // Platform,
  // StatusBar,
  Animated,
  // ScrollView,
  StyleSheet,
  // TextStyle,
  ViewStyle,
  // useWindowDimensions,
  // Dimensions,
  // Text,
  View,
  // PanResponderGestureState,
  // NativeSyntheticEvent,
  // NativeScrollEvent
} from 'react-native';
// import { useSafeAreaInsets } from 'react-native-safe-area-context';
// import { connect } from 'react-redux';
// import { decrementCounter, incrementCounter } from './counterSlice'
// import clsx from 'clsx';
// import PropTypes from 'prop-types';
// import { Helmet } from 'react-helmet';
// import { Link } from 'react-router-dom';
// import { loadPartnerProfile } from 'mainApp/actions/partner';
// import {
//     changeDrawerState,
// } from 'mainApp/actions/ui';

import {
  // Button,
  // Dialog,
  // DialogActions,
  // DialogContent,
  // DialogTitle,
  // Divider,
  // FormControl,
  // Grid,
  // Box,
  // InputLabel,
  // MenuItem,
  // Select,
  // TextField,
  Theme,
  Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

// utils
import {
  // css,
  // isIosDevice,
  // getViewportHeight,
} from '../../utils';
// import { LIVE_STREAM_PRICE, LOCATION_TYPES } from 'mainApp/constants';

// components
import SlidingUpPanel, { /*SlidingUpPanelAnimationConfig*/ } from 'rn-sliding-up-panel';
import RoundedContainer from '../RoundedContainer/RoundedContainer';

import CloseIcon from '../../icons/Close2Icon';
// import Icon from 'mainApp/components/Icon';
// import { ProgressiveImage } from 'mainApp/components/ProgressiveImage';
// import { DirectBookingForm } from 'mainApp/components/DirectBookingForm';
// import DrawerGoals from 'mainApp/components/DrawerGoals';
// import DrawerDayAndTime from 'mainApp/components/DrawerDayAndTime';
// import DrawerSessionType from 'mainApp/components/DrawerSessionType';


// import BookingFlowSessionSelector from 'mainApp/components/BookingFlowSessionSelector';


// hooks
import useHeight from '../../hooks/useHeight/useHeight';
import useBodyScrollLock from '../../hooks/useBodyScrollLock/useBodyScrollLock';

// import defaultTrainerPhoto from 'images/generic-trainerphoto.svg';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    width: '600px',
    'min-height': '400px',
    [theme.breakpoints.down('xs')]: {
      width: 'calc(100vw - 32px)',
    },
    '& .inputSelect': {
      width: 'calc(100% - 35px)',
    },
  },
  button: {
    float: 'right',
  },
  paper: {
    [theme.breakpoints.down('xs')]: {
      margin: '16px',
    },
  },
  drawer: {

  },
  gutterBottom: {
    'margin-bottom': '1em',
  },
  headline: {
    'margin-bottom': '1.3em',
    'font-size': '1.1rem',
  },
  listSection: {
    margin: '2em 0 0.8em',
    '&:first-child': {
      margin: '1em 0 2em 0',
    },
  },
  closeDrawer: {
    cursor: 'pointer',
    display: 'flex',
    background: 'transparent',
    border: '0',
    margin: '0',
    padding: '0',
    color: theme.red,
  },

}));

// const { height: deviceHeight } = Dimensions.get('window');

// const propTypes = {
//   // children: PropTypes.object, // JSX.Element,
//   onClose: PropTypes.func,
//   // activeState: PropTypes.string,
//   // title: PropTypes.string,
//   // subtitle: PropTypes.string,
//   // onNextClick: PropTypes.func.isRequired,
// };

const defaultProps = {
  // bookingStep: 1,
  isOpening: true,
  allowDragging: false,
};

// const styles = {

// };

// const panelStyles = {
//   backdrop: {
//       position: 'fixed',
//       'z-index': 1000,
//   },
//   container: {
//     position: 'fixed',
//     // flex: 1,
//     // 'background-color': 'rgb(255, 255, 255)',
//     // 'align-items': 'center',
//     // 'justify-content': 'center',
//     'z-index': 1000,
//   },
// };

const CLOSE_TIMEOUT = 300;

// interface ErrorDialogProps {
//   dismissError: Function;
//   error: TwilioError | Error | null;
// }

// type ReactNode = {} | null | undefined;

// type Props = {
//   title: string;
//   children?: React.ReactNode;
// };

// const ios = Platform.OS === 'ios';

interface DrawerProps {
  children?: any; // React.ReactElement; // React.ReactNode;
  attachRef?: any;
  isOpen: boolean;
  isOpening?: boolean;
  allowDragging: boolean;
  title: string;
  draggableRange?: any;
  snappingPoints?: any;
  containerStyle?: any;
  // onClose(...args: any[]): any;
  onClose(): void;
  onFullyOpen?: any;
  onBottomReached?: any;
  // type: "submit" | "button";
}

// type Ref = HTMLElement;
type Ref = SlidingUpPanel;

/**
 * @public
 */
export const Drawer = React.forwardRef<Ref, DrawerProps>((props, outerRef): JSX.Element => {
  const [isOpen, setIsOpen] = useState<boolean>(props.isOpen);
  const [isFullyOpen, setIsFullyOpen] = useState<boolean>(false);
  // const [scrollEnabled, setScrollEnabled] = useState<boolean>(true);
  // const [allowDragging, setAllowDragging] = useState<boolean>(props.allowDragging);
  // const [atTop, setAtTop] = useState<boolean>(true);
  const [atBottom, setAtBottom] = useState<boolean>(true);
  // const [backdropShow, setBackdropShow] = useState<boolean>(false);

  // const dispatch = useDispatch();

  // console.log('allowDragging: ', allowDragging);

  // const deviceHeight = useWindowDimensions().height;
  // const deviceHeight = getViewportHeight();
  const deviceHeight: number = useHeight(); // getViewportHeight();
  // const insets = useSafeAreaInsets();
  const statusBarHeight: number = 24; //ios ? insets.bottom : StatusBar.currentHeight as number;

  const classes = useStyles();

  const draggableRange = props.draggableRange ?
    props.draggableRange : {
      top: deviceHeight - statusBarHeight,
      bottom: 0 // deviceHeight / 2.8
    };

  const snappingPoints = props.snappingPoints ?
    props.snappingPoints : [
      draggableRange.top,
      // draggableRange.bottom
    ];

  const panelRef = React.useRef<SlidingUpPanel | null>(null);
  const [panelPositionVal] = useState(new Animated.Value(draggableRange.bottom));
  const panelPositionValueListenerRef = React.useRef('');

  const attachRef = useCallback(node => {
    const ref = props.attachRef;
    // const {
        // attachLocationPickerRef: ref
    // } = props;

    panelRef.current = node;

    if (ref == null) {
        return;
    }

    if (typeof ref === 'function') {
        ref(node);

        return;
    }

    if (typeof ref === 'object') {
        ref.current = node;
        return;
    }
  }, [props.attachRef]);

  const { /*bottomBarHeight, */refCallback, targetRef } = useBodyScrollLock(isOpen);

  const onAnimatedValueChange = useCallback(({ value }) => {
    // console.log('onAnimatedValueChange draggableRange.top', draggableRange.top);
    if (value === draggableRange.top) {
      // At top position
      // console.log('At top position');
      setIsFullyOpen(true);
      setAtBottom(false);
      props.onFullyOpen && props.onFullyOpen();
    }

    // console.log('onAnimatedValueChange.value: ', value);

    // console.log('draggableRange.top: ', draggableRange.top);
    // console.log('draggableRange.bottom: ', draggableRange.bottom);

    if (value === draggableRange.bottom) {
      // At bottom position
      // console.log('At bottom position');
      // setAtBottom(true);
      // setIsFullyOpen(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [draggableRange.top, draggableRange.bottom, props.onFullyOpen]);
  // }, [draggableRange.top, draggableRange.bottom, setIsFullyOpen]);

  // useEffect(() => {
  //   if (props.attachRef) {
  //     props.attachRef(panelRef);
  //   }
  // }, [props.attachRef]);


  // outerRef = panelRef;
  // outerRef = outerRef == null ? null : panelRef;

  // useEffect(() => {
  //     if (props.partner && props.partner.id && props.partner.id !== 0) {
  //         props.loadPartnerProfile(props.userId !== '0' ? props.userId : undefined, props.partner.id);
  //     }
  // }, [props.partner]);

  const close = useCallback(() => {
    return new Promise((resolve, reject) => {
      setIsFullyOpen(false);

      panelRef && panelRef?.current?.hide();
      // TODO: move to useEffect?
      // setBackdropShow(false);

      // props.onClose();

      setTimeout(() => {
        // setIsOpen(false);
        panelPositionVal.removeListener(panelPositionValueListenerRef.current);
        panelPositionValueListenerRef.current = '';
        // props.onClose && props.onClose();
        resolve(null);
      }, CLOSE_TIMEOUT);
    });
  }, [panelPositionVal/*, props.onClose*/]);

  useEffect(() => {
    if (!props.attachRef.current) {
    // if (!panelRef.current) {
      if (!props.isOpen && isOpen) {
        setIsOpen(false);
        // // TODO: move to useEffect?
        // // panelPositionVal.removeListener(onAnimatedValueChange);
        // if (panelPositionValueListenerRef.current !== '') {
        //   panelPositionVal.removeListener(panelPositionValueListenerRef.current);
        //   panelPositionValueListenerRef.current = '';
        // }
      }

      return;
    }

    if (props.isOpen) {
      let targetEl = panelRef?.current; // panelRef.current;

      // TODO: move to useEffect?
      // panelPositionValueListenerRef.current = panelPositionVal.addListener(onAnimatedValueChange);

      // setTimeout(() => {
        // const deviceHeight = useWindowDimensions().height; // .get('window');

        // targetEl.show(deviceHeight - 24/* , 0.5 */); // 24px top gap with 0.5 velocity
        setAtBottom(false);
        // targetEl.show({
        //   velocity: PANEL_VELOCITY,
        //   toValue: draggableRange.top
        // });
        // targetEl?.show();
        targetEl?.show(draggableRange.top);
      // }, 300);

      // setTimeout(() => {
      //   panelRef?.current?.forceUpdate();
      // }, 300);
    }

    if (props.isOpen && !isOpen) {
      setIsOpen(true);

      const targetEl = ReactDOM.findDOMNode(targetRef?.current);

      (targetEl as HTMLElement).scrollTop = 0;

      // setBackdropShow(true);
    } else if (!props.isOpen && isOpen) {
      // We need setTimeout here, because useBodyScrollLock should have a ref.
      // Without it, it can't enable scroll back again
      setTimeout(() => {
        setIsOpen(false);
      }, CLOSE_TIMEOUT);

      // targetEl.hide();
      close();
      // // TODO: move to useEffect?
      // if (panelPositionValueListenerRef.current !== '') {
      //   panelPositionVal.removeListener(panelPositionValueListenerRef.current);
      //   panelPositionValueListenerRef.current = '';
      // }
    }

    return () => {
    };
  }, [props.isOpen, props.attachRef, draggableRange.top, isOpen, close, targetRef]);

  useEffect(() => {
    // console.log('useEffect draggableRange.top', draggableRange.top);
    if (panelPositionValueListenerRef.current !== '') {
      panelPositionVal.removeListener(panelPositionValueListenerRef.current);
      panelPositionValueListenerRef.current = '';
    }

    if (isOpen) {
      panelPositionValueListenerRef.current = panelPositionVal.addListener(onAnimatedValueChange);

      panelRef?.current?.show(draggableRange.top);
    }
  }, [isOpen, panelPositionVal, draggableRange.top, onAnimatedValueChange]);

  // useEffect(() => () => { props.isOpen && props.onClose && props.onClose(); }, [props.isOpen, props.onClose]);

  // hideDrawer () {
  //     return new Promise((resolve, reject) => {
  //         this.DrawerRef.hide();

  //         setTimeout(() => {
  //             this.context.changeDrawerState(null);
  //             this.context.hideDrawer();

  //             resolve();
  //         }, 500);
  //     });
  // },


  const handleBottomReached =  useCallback(() => {
    setAtBottom(true);
    // close();
    // setIsOpen(false);
    // setIsFullyOpen(false);
    // props.onClose && props.onClose();
    props.onBottomReached && props.onBottomReached();
    // resolve(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.onClose, props.onBottomReached]);

  // // fired when panel is finished being dragged up or down
  // // if panel is dragged to 'top' position, then we switch to scrollmode
  // const onMomentumDragEnd = useCallback((value: number) => {
  //   if (value === draggableRange.top && !scrollEnabled) {
  //     setScrollEnabled(true);
  //     setAtTop(true);
  //   }
  // }, [draggableRange, scrollEnabled, setScrollEnabled, setAtTop]);


  // // fired when scroll is finished inside the panel,
  // // if the content in the panel has scrolled to the very top,
  // // then we allow the panel to be dragged down
  // // (only if the next gesture is down, not up)
  // // const onMomentumScrollEnd = useCallback(({ clientHeight, scrollHeight, scrollTop }: { clientHeight: number, scrollHeight: number, scrollTop: number }) => {
  // const onMomentumScrollEnd = useCallback((event: NativeSyntheticEvent<NativeScrollEvent>) => {
  //   const { nativeEvent } = event;

  //   if (nativeEvent.contentOffset.y === 0) {
  //   // if (scrollTop === 0) {
  //     setAtTop(true);

  //     // if (ios) {
  //       setAllowDragging(true);
  //     // }
  //   }
  // }, [setAtTop, setAllowDragging]);

  //   // fired when scroll is finished inside the panel,
  // // if the content in the panel has scrolled to the very top,
  // // then we allow the panel to be dragged down
  // // (only if the next gesture is down, not up)
  // const onScroll = useCallback(({ clientHeight, scrollHeight, scrollTop }: { clientHeight: number, scrollHeight: number, scrollTop: number }) => {
  // // const onMomentumScrollEnd = useCallback((event: NativeSyntheticEvent<NativeScrollEvent>) => {
  //   // const { nativeEvent } = event;

  //   return;
  //   // if (nativeEvent.contentOffset.y === 0) {
  //   if (scrollTop === 0) {
  //     setAtTop(true);

  //     // if (ios) {
  //       setAllowDragging(true);
  //     // }
  //   }
  // }, [setAtTop, setAllowDragging]);

  // const PANEL_VELOCITY = (ios || isIosDevice) ? 1 : 2.3;
  // const hideFullScreenPanelOptions: SlidingUpPanelAnimationConfig = {
  //   velocity: PANEL_VELOCITY,
  //   toValue: draggableRange.bottom
  // };

  // // if panel is at the top and scrolling is allowed
  // // check the velocity of the drag,
  // // if the velocity is downward, then we animate the panel to its bottom state
  // // if the velocity is upward, we treat the drag like a scroll instead
  // const onDragStart = useCallback((_: number, gestureState: PanResponderGestureState) => {

  //   // console.log('onDragStart - gestureState.vy: ', gestureState.vy, 'atTop: ', atTop, 'scrollEnabled: ', scrollEnabled);

  //   if (atTop && scrollEnabled) {
  //     if (gestureState.vy > 0) { // Swipe up. Swipe down it's a minus
  //       setScrollEnabled(false);

  //       // if (ios) {
  //         setAllowDragging(true);
  //       // }

  //       if (panelRef && panelRef.current) {
  //         panelRef?.current?.show(hideFullScreenPanelOptions);
  //         // console.log('show!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!');
  //       }
  //     } else {
  //       setAtTop(false);

  //       // if (ios) {
  //         setAllowDragging(false);
  //       // }
  //     }
  //   }
  // }, [atTop, scrollEnabled, panelRef, setAtTop, setAllowDragging, setScrollEnabled]);

  // const handleMomentumScrollEnd = () => {
  //     if (!isFullyOpen) {
  //         setIsFullyOpen(true);
  //     }
  // };

  // const handleDateTimeSelect = (dateTime, dateStr, time) => {
  //   const { partner, changeBookingTime } = props;

  //   // Pass through callback to parent
  //   props.onDateTimeSelect && props.onDateTimeSelect(dateTime, time);
  // };


  // const handleCtaClick = useCallback((e) => {

  //   if (props.activeState === 'dayTime') {
  //     // props.onSubmit && props.onSubmit();
  //     close();
  //   }

  //   props.onNextClick && props.onNextClick();

  // }, [props.activeState, props.onNextClick]);

  // const handleBackButtonClick = useCallback((e) => {
  //   if (props.activeState === 'sessionType') {
  //     props.changeDrawerState('goals');
  //   } else {
  //     props.changeDrawerState('sessionType');
  //   }

  // }, [props.activeState, props.changeDrawerState]);

  // const handleDateSelect = (date, dateStr, time) => {
  //   // const { partner, changeBookingTime } = props;

  //   // Pass through callback to parent
  //   props.onDateSelect && props.onDateSelect(date, time);
  // };

  // const trainerPictureUrl = props.partner && getPartnerPictureUrl(props.partner);

  // const canBook = true;

  // const title = props.activeState === 'goals'
  //   ? 'Your goal'
  //   : props.activeState === 'dayTime'
  //     ? 'Day & Time'
  //     : 'Session type';

  // const subtitle = props.activeState === 'goals'
  //   ? 'What\'s your primary goal in fitness'
  //   : props.activeState === 'dayTime'
  //     ? 'When is more comfortable for you?'
  //     : 'Online or In-Person Session?';


  return (
    <aside className={classes.drawer}>
      {/*isOpen && backdropShow && <View style={panelStyles.backdrop} />*/}
      <SlidingUpPanel
        // ref={panelRef}
        // @ts-ignore
        ref={attachRef}

        animatedValue={panelPositionVal}
        //allowDragging={isDraggable}
        allowDragging={props.allowDragging}

        draggableRange={draggableRange}
        snappingPoints={snappingPoints}

        // draggableRange={{ top: height - 24, bottom: '0' }}
        // snappingPoints={[118, height - 100]}


        // onDragStart={ (position) => { this.setState({ isDragged: true }); } }
        // onDragEnd={ (position) => { this.setState({ isDragged: false }); } }


        // onMomentumDragEnd={onMomentumDragEnd}
        // onDragStart={onDragStart}
        onBottomReached={handleBottomReached}


        // onFullyOpen={ () => setIsFullyOpen(true) }
        //snappingPoints={[panelExpandedY]}


        backdropStyle={panelStyles.backdrop}
        containerStyle={panelStyles.container}

        backdropOpacity={atBottom ? 0 : 0.75}
        // backdropOpacity={isFullyOpen ? 0.75 : 0}
        showBackdrop={true}

        height={deviceHeight - 24}
        friction={0.44}
        // @ts-ignore
        children={(dragHandlers) => {
          {/* here should be props.isOpen because otherwise
            useBodyScrollLock can't enable scroll back again without the ref */}
          return (
          <View
            // ref={refCallback}
            style={styles.container}
            // style={styles.panelContent}
          >
            {(isOpen || true) && (
              <>
            <View
              style={styles.panelHeader}
              // justifyContent="space-between"
              {...dragHandlers}
            >
              <div
                style={{
                  position: "absolute",
                  marginTop: '4px'
                }}
              >
                <button className={classes.closeDrawer} onClick={props.onClose}>
                  <CloseIcon />
                </button>
              </div>
              <Typography
                variant="button"
                color="primary"
                className={''}
                style={{
                  flexGrow: 1,
                  marginTop: '3px',
                  marginBottom: '3px',
                  height: '26px'
                }}
              >
                {props.title}
              </Typography>
            </View>
            <RoundedContainer
              attachRef={refCallback}
              style={props.containerStyle}
              // style={{ height: 'calc(100% - 146px)' }}
              // style={{ height: '100%'/*'calc(100% - 126px)'*/ }}
              // innerContainerStyle={{ 'min-height': '100%', 'padding-bottom': 16 }}
            >
              {props.children && React.cloneElement(props.children, { isOpen, isFullyOpen, /*scrollEnabled, onMomentumScrollEnd, */refCallback, /*onScroll, */close })}
            {/*props.children*/}
          </RoundedContainer>
          </>
          )}
          </View>)
        }}
      >
      </SlidingUpPanel>
    </aside>
  );
});

type Style = {
  // panel: ViewStyle;
  container: ViewStyle;
  panelHeader: ViewStyle;
  // title: TextStyle;
  // icon: ImageStyle;
};


// const styles = StyleSheet.create<Style>({
//   panel: {
//     borderBottomColor: '#cbcfd5',
//     borderBottomWidth: 1,
//     'padding-top': '1rem',
//     'padding-bottom': '1rem',
//     'padding-right': '.5rem',
//     'padding-left': '.5rem',
//     'margin-right': '1rem',
//     'margin-left': '1rem',
//     'flex-direction':  'row',
//   },
//   container: {
//     flex: 1,
//     'background-color': 'rgb(255, 255, 255)',
//     'align-items': 'center',
//     'justify-content': 'center',
//     'border-radius': '8px',
//     height: '100%',
//   },
// });

const styles = StyleSheet.create<Style>({
  // panel: {
  //   borderBottomColor: '#cbcfd5',
  //   borderBottomWidth: 1,
  //   'padding-top': '1rem',
  //   'padding-bottom': '1rem',
  //   'padding-right': '.5rem',
  //   'padding-left': '.5rem',
  //   'margin-right': '1rem',
  //   'margin-left': '1rem',
  //   'flex-direction':  'row',
  // },
  container: {
    flex: 1,
    backgroundColor: 'white', // optimisations
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 8,
    height: '100%',
  },

  panelHeader: {
    marginBottom: '-8px',
    backgroundColor: 'rgb(248, 248, 248)', // #F8F8F8
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    width: '100%',

    // userSelect: 'none',


    paddingTop: '8px', //16,
    paddingBottom: '16px',
    paddingLeft: '16px',
    paddingRight: '16px',
    // padding: '8px 16px 16px',

    // display="flex"
    textAlign: 'center',
    // padding: '8px 16px',
  },
});

// const containerStyles: React.CSSProperties = {
//   // container: { /* panel-body */
//     flex: 1,
//     'background-color': 'rgb(255, 255, 255)',
//     'align-items': 'center',
//     'justify-content': 'center',
//     'border-radius': '8px',
//     height: '100%',
//   // },
//   // panelHeader: {
//   //   'margin-bottom': '-8px',
//   //   'background-color': theme.greyLight,
//   //   'border-top-left-radius': '8px',
//   //   'border-top-right-radius': '8px',
//   // }
// };

type PanelStyle = {
  backdrop: ViewStyle;
  container: ViewStyle;
  // title: TextStyle;
  // icon: ImageStyle;
};


const panelStyles = StyleSheet.create<PanelStyle>({
  backdrop: {
    // @ts-ignore
    position: 'fixed', // TODO: refactor Availability Time Picker, move <aside /> higher in components
    // opacity: 0,
    // position: 'absolute',
    backgroundColor: 'black', // optimisations
    // 'z-index': 1000,


    //       // position: absolute;
    // top: 0,
    // left: '0',
    // right: '0',
    // bottom: '0',
    // 'background-color': 'rgb(0, 0, 0)',
    // // z-index: 1000;
    // opacity: 0.75,
    // // 'pointer-events': 'auto'
  },
  container: {
    // @ts-ignore
    position: 'fixed',
    // position: 'absolute',
    zIndex: 1004,
  },


});

Drawer.displayName = 'TruBeDrawer';
// Drawer.propTypes = propTypes;
Drawer.defaultProps = defaultProps;

// const mapStateToProps = (state, ownProps) => ({});

// const dispatchProps = {
//   changeDrawerState,
//   // loadPartnerProfile,
// };

// export default connect(
//   mapStateToProps,
//   dispatchProps,
//   null,
//   { forwardRef: true }
// )(Drawer);
